import React from "react";
import Courses from "../../components/Courses/Courses";

const CoursesPage = () => {
  return <Courses />;
};

export default CoursesPage;
